import { useEffect } from 'react';

// Tables that should keep their grid on phones opt out with this class.
const OPT_OUT = 'no-mobile-cards';

/**
 * On phones every admin list table is restyled as a stack of cards (see
 * assets/css/mobile.css). Each card row needs its column name, so this copies
 * the <thead> text onto every body cell as `data-label`. Runs once on mount
 * and again whenever the DOM changes (pages render their rows after fetching).
 * Renders nothing.
 */
const labelTables = () => {
    document.querySelectorAll('table').forEach((table) => {
        if (table.classList.contains(OPT_OUT)) return;
        const headers = [...table.querySelectorAll(':scope > thead > tr:last-child > th')]
            .map((th) => th.textContent.trim());
        if (!headers.length) return;

        table.classList.add('mobile-cards');
        table.querySelectorAll(':scope > tbody > tr').forEach((row) => {
            let column = 0;
            [...row.children].forEach((cell) => {
                const span = cell.colSpan || 1;
                // A cell spanning the row ("No data found", a loader) has no column.
                const label = span > 1 ? '' : headers[column] || '';
                if (cell.getAttribute('data-label') !== label) cell.setAttribute('data-label', label);
                column += span;
            });
        });
    });
};

const MobileTableLabels = () => {
    useEffect(() => {
        let frame = null;
        const schedule = () => {
            if (frame) return;
            frame = requestAnimationFrame(() => {
                frame = null;
                labelTables();
            });
        };
        labelTables();
        const observer = new MutationObserver(schedule);
        observer.observe(document.body, { childList: true, subtree: true });
        return () => {
            observer.disconnect();
            if (frame) cancelAnimationFrame(frame);
        };
    }, []);

    return null;
};

export default MobileTableLabels;
